import React, { forwardRef } from 'react';

const features = [
  {
    icon: '✨',
    title: 'AI-Powered Sentence Correction',
    description: 'Improve your writing with instant grammar correction and clarity suggestions powered by AI.'
  },
  {
    icon: '📘',
    title: 'Personal Flashcards',
    description: 'Create, save, and review flashcards tailored to your learning journey.'
  },
  {
    icon: '🔁',
    title: 'Smart Quizzes',
    description: 'Practice with dynamic quizzes generated from your flashcards and track your progress.'
  },
  {
    icon: '🌍',
    title: 'Fast Translation',
    description: 'Translate words and phrases quickly using real-time translation APIs.'
  },
  {
    icon: '🔊',
    title: 'Text-to-Speech',
    description: 'Hear accurate pronunciation of translations using the Web Speech API.'
  },
];

const Features = forwardRef((props, ref) => {
  return (
    <section ref={ref} className="bg-gray py-16 px-6">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-blue mb-2">
  Powerful Features to Boost Your Learning
</h2>
<p className="text-charcoal/80 text-lg md:text-xl mb-10">
  Tools tailored to accelerate your fluency journey.
</p>

        <div className="flex flex-wrap justify-center gap-6">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="flex flex-col bg-white rounded-2xl shadow-md p-6 w-full sm:w-[45%] md:w-[36%] lg:w-[18%] min-h-[250px] hover:shadow-lg transition duration-300"
            >
              <div className="mx-auto text-3xl mb-4 w-14 h-14 flex items-center justify-center rounded-full text-white">
                {feature.icon}
              </div>
              <h3 className="text-lg font-semibold text-purple mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-charcoal/80">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
});

export default Features;
